import GATSBY_COMPILED_MDX from "/opt/build/repo/src/pages/blog/building-teamspectives-pulse-survey-data-model.mdx";
import React from "react";
import {graphql} from "gatsby";
import Layout from "../components/Layout";
import {HTMLContent} from "../components/Content";
import PreviewCompatibleImage from "../components/PreviewCompatibleImage";
import teamworkImg from "../img/illustration-teamwork.svg";
import Tags from "../components/Tags";
import PageHead from "../components/PageHead";
import Leadoo from "../components/Leadoo";
export const Head = ({data}) => {
  const post = data.markdownRemark ?? data.mdx;
  console.log(post);
  return React.createElement(PageHead, {
    title: post.frontmatter.title,
    description: post.frontmatter.seoDescription ?? post.frontmatter.excerpt
  });
};
export const BlogPostTemplate = ({content, excerpt, tags, image: mainImage, title, author}) => {
  return React.createElement("article", {
    className: "blog-post"
  }, React.createElement("section", {
    className: "blog-post-head"
  }, React.createElement("div", null, React.createElement(Tags, {
    tags: tags ?? []
  }), React.createElement("h1", null, title), React.createElement("p", {
    className: "excerpt"
  }, excerpt), React.createElement("div", {
    className: "author"
  }, author.image && React.createElement(PreviewCompatibleImage, {
    imageInfo: author.image
  }), React.createElement("div", null, React.createElement("p", {
    className: "author-name"
  }, author.name), React.createElement("p", {
    className: "author-bio"
  }, author.bio)))), React.createElement("img", {
    className: "blog-post-head-illustration",
    alt: "",
    src: teamworkImg
  })), mainImage && React.createElement(PreviewCompatibleImage, {
    imageInfo: mainImage,
    style: {
      borderRadius: "12px"
    }
  }), React.createElement("section", {
    className: "blog-post-content"
  }, content), React.createElement(Leadoo, {
    name: "Blog pages"
  }));
};
const BlogPost = props => {
  const data = props.data;
  const post = data.markdownRemark ?? data.mdx;
  return React.createElement(Layout, null, React.createElement(BlogPostTemplate, Object.assign({}, post.frontmatter, {
    content: post.html ? React.createElement(HTMLContent, {
      content: post.html
    }) : props.children
  })));
};
BlogPost
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPost, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        date(formatString: "YYYY-MM-DD")
        title
        tags
        excerpt
        seoDescription
        image {
          childImageSharp {
            gatsbyImageData(quality: 100, width: 1200)
          }
        }
        author {
          name
          bio
          image {
            childImageSharp {
              gatsbyImageData(quality: 100, width: 44)
            }
          }
        }
      }
    }
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        tags
        date(formatString: "YYYY-MM-DD")
        title
        excerpt
        seoDescription
        image {
          childImageSharp {
            gatsbyImageData(quality: 100, width: 1200)
          }
        }
        author {
          name
          bio
          image {
            childImageSharp {
              gatsbyImageData(quality: 100, width: 44)
            }
          }
        }
      }
    }
  }
`;
